<mat-expansion-panel class="box-shadow border-radius-0" (afterExpand)="onExpanded()" *ngIf="{
  armedPax: armedPax$ | async
} as vm">
  <mat-expansion-panel-header>

    <mat-panel-title class="panel-header-title">
      <mat-icon [inline]="true" class="opacity-4">local_police</mat-icon>
      <span>Armed Pax</span>
    </mat-panel-title>

    <mat-panel-description *ngIf="!vm.armedPax?.isLoading && vm.armedPax?.response?.armedPax!.length > 0"
      class="caution-color text-base font-normal flex-center" @fadeIn>
      {{ vm.armedPax?.response?.armedPax?.length }} Listed
    </mat-panel-description>

    <mat-panel-description *ngIf="!vm.armedPax?.isLoading && vm.armedPax?.response?.armedPax?.length === 0"
      class="success-color text-base font-normal flex-center" @fadeIn>
      None
    </mat-panel-description>

    <mat-panel-description *ngIf="vm.armedPax?.isLoading" class="opacity-4 avail flex-center">
      <mat-spinner color="accent" diameter="24"></mat-spinner>
    </mat-panel-description>

  </mat-expansion-panel-header>

  <ng-template matExpansionPanelContent>

    <div *ngIf="!vm.armedPax?.isLoading && (vm.armedPax?.response && vm.armedPax!.response!.armedPax.length > 0)">
      <table>
        <thead>
          <th></th>
          <th class="text-left">Name</th>
          <th class="text-left">Seat</th>
        </thead>
        <tbody>
          <tr *ngFor="let armedPax of vm.armedPax?.response?.armedPax; let i = index" class="text-sm">
            <td class="text-xs text-right opacity-4">{{ i + 1 }}</td>
            <td>{{ armedPax.name | titlecase }}</td>
            <td>{{ armedPax.seat }}</td>
          </tr>
          <tr></tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="!vm.armedPax?.isLoading && (vm.armedPax?.response && vm.armedPax!.response!.armedPax.length === 0)"
      class="none-listed text-sm">
      None Listed
    </div>

    <div *ngIf="vm.armedPax?.isLoading" class="flex-center">
      <mat-spinner color="accent" [diameter]="32"></mat-spinner>
    </div>

    <div *ngIf="vm.armedPax?.response?.armedPax!.length > 0" class="mt-24">
      <button mat-stroked-button color="primary" class="mod-button width-100"
        (click)="onSabreTextClick(vm.armedPax?.response?.sabreText || '', vm.armedPax?.response?.timestamp)"
        onclick="blur()">
        <span class="text-sm">Sabre Text</span>
      </button>
    </div>

    <div class="data-status">
      <app-data-status [isLoading]="vm.armedPax?.isLoading" [timestamp]="vm.armedPax?.response?.timestamp"
        (refresh)="refresh()"></app-data-status>
    </div>

    <mat-progress-bar *ngIf="vm.armedPax?.isLoading" class="progress-bar-bottom" color="accent"
      mode="indeterminate"></mat-progress-bar>

  </ng-template>
</mat-expansion-panel>